import React from 'react'
import { Col, Row, Select } from 'antd'
import { /*Button, ButtonActionBar,*/ Typography } from 'modules/core/components'
import { connect } from 'react-redux'
// import { PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next'
import CombinationDimensionsTable from '../CombinationDimensionsTable/CombinationDimensionsTable'
import configuration from 'modules/configuration'
import { generateSelectOptions, handleSelectAll } from 'modules/core/utils'

const OriginDimensions = ({
  loadingTable,
  loading,
  dataKey,
  // deleteDimensionsSelection,
  // addDimensionsSelections,
  rowsDimensions,
  setDimensionsSelection,
  dimensionsSelection,
  allDimensionsList,
  areAllSelected,
  setAreAllSelected,
  currencyList,
  setOriginCurrencyIds,
  currencyLoading,
  enableCurrencySelect,
}) => {
  const { t } = useTranslation()

  const columnActions = [
    ...(enableCurrencySelect
      ? [
          {
            dataIndex: 'origin_currency_ids',
            width: 30,
            render: () => {
              return (
                <Select
                  placeholder="Moneda"
                  style={{ width: 200 }}
                  mode="multiple"
                  loading={currencyLoading}
                  maxTagCount={1}
                  maxTagTextLength={8}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  options={generateSelectOptions({
                    options: currencyList.data,
                    includeOptionAll: true,
                  })}
                  onChange={(ids) => {
                    handleSelectAll({
                      values: ids,
                      allValues: currencyList.data,
                      areAllSelected,
                      onSetValues: (values) => setOriginCurrencyIds(values),
                      onSetAreAllSelected: (state) => setAreAllSelected(state),
                    })
                  }}
                />
              )
            },
          },
        ]
      : []),
  ]

  return (
    <Row gutter={[12, 12]}>
      <Col span={24}>
        <Typography.Body level={2}>
          {t('CONFIG_RULES_ORIGIN_VALUES_STEP_ORIGIN_SUBTITLE')}
        </Typography.Body>
      </Col>
      <Col span={24}>
        <CombinationDimensionsTable
          dataSource={rowsDimensions.origin_dimensions}
          loadingTable={loadingTable}
          dataKey={dataKey}
          loading={loading}
          setDimensionsSelection={setDimensionsSelection}
          dimensionsSelection={dimensionsSelection.origin_dimensions}
          dimensionsList={allDimensionsList}
          extraColumns={columnActions}
          areAllSelected={areAllSelected}
          setAreAllSelected={setAreAllSelected}
          currencyList={currencyList}
        />
      </Col>
      {/* <Col span={24}>
                <ButtonActionBar>
                    <Button.LinkWhitLeftIcon
                        icon={<PlusCircleOutlined />}
                        onClick={()=> addDimensionsSelections({key: dataKey})}
                        title='ADJUSTMENT_ADD_MOVEMENT_ACTION'
                    />
                </ButtonActionBar>
            </Col> */}
    </Row>
  )
}

const mapStateToProps = (state) => ({
  rowsDimensions: configuration.selectors.getRowsDimensions(state),
  dimensionsSelection: configuration.selectors.getDimensionsSelection(state),
  allDimensionsList: configuration.selectors.getAllDimensionsList(state),
})

const mapDispatchToProps = {
  deleteDimensionsSelection: configuration.actions.deleteDimensionsSelection,
  // addDimensionsSelections: configuration.actions.addDimensionsSelection,
  setDimensionsSelection: configuration.actions.setDimensionsSelection,
}

export default connect(mapStateToProps, mapDispatchToProps)(OriginDimensions)
